import React, { useState, forwardRef } from "react";
import deleteSvg from "../../../../assets/images/delete.svg";
import styles from "./AudioEditorLoader.module.css";

interface AudioEditorLoaderItemProps {
    title: string;
    image?: string;
    onClick?: () => void;
    isSelected?: boolean;
    onDelete?: () => void;
}

const AudioEditorLoaderItem = forwardRef<HTMLDivElement, AudioEditorLoaderItemProps>(
    ({ title, image = require("../../../../assets/images/note.png"), onClick, isSelected = false, onDelete }, ref) => {
        const [isHovered, setIsHovered] = useState(false);

        const handleDeleteClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (onDelete) {
                onDelete();
            }
        };

        return (
            <div
                ref={ref}
                className={`${styles.itemContainer} ${isSelected ? styles.itemContainerSelected : ""}`}
                onClick={onClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className={`${styles.itemBox} ${isSelected ? styles.itemBoxSelected : ""}`}>
                    {isHovered && onDelete && (
                        <div className={styles.itemDelete} onClick={handleDeleteClick}>
                            <img src={deleteSvg} alt="Delete" className={styles.itemDeleteIcon} />
                        </div>
                    )}
                    <img src={image} alt={title} className={styles.itemImage} />
                </div>
                {title && <p className={styles.itemTitle}>{title}</p>}
            </div>
        );
    },
);

export default AudioEditorLoaderItem;
